import { render, staticRenderFns } from "./prev-next-arrows.vue?vue&type=template&id=75da2f11&"
import script from "./prev-next-arrows.vue?vue&type=script&lang=ts&"
export * from "./prev-next-arrows.vue?vue&type=script&lang=ts&"
import style0 from "./prev-next-arrows.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports